export const SIGNUP_EMAIL_KEY = "signupEmail";
export const SJ_FE_MONOREPO = "SJ_FE_MONOREPO";
